module.exports = __webpack_public_path__ + "static/media/client-unboundmerino.bd9de85d.png";